import { gql } from "../__generated__";

export const GetObjectTechniques = gql(`
  query GetObjectTechniques($take: Int, $where: ObjektEigenschaftTechnikWhereInput) {
    items: objektEigenschaftTechniks(take: $take, where: $where) {
      id
      name
    }
  }
`);
